import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TailoredShineSolutions() {
  return <section data-section-id="222836" id="punti-del-programma" className="w-full py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center space-y-4 text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-default font-bold tracking-tight text-primary">
            La nostra visione per Albano
          </h2>
          <p className="max-w-[800px] text-muted-foreground font-default text-base leading-relaxed">
            Albano Laziale merita un'amministrazione che guardi al futuro con competenza e dedizione. Il nostro impegno si fonda sulla valorizzazione del patrimonio storico, il potenziamento dei servizi ai cittadini e una gestione trasparente delle risorse pubbliche. Vogliamo una città più sicura, sostenibile e inclusiva, dove ogni quartiere, da Pavona a Cecchina, si senta parte integrante di un progetto comune di crescita e benessere.
          </p>
        </div>

        <div className="max-w-3xl mx-auto text-center space-y-6">
          <p className="text-muted-foreground font-default">
            Il nostro programma elettorale non è solo un elenco di promesse, ma un piano d'azione concreto sviluppato attraverso l'ascolto attivo della comunità. Ogni punto è stato studiato per rispondere alle reali esigenze del territorio, garantendo fattibilità e sostenibilità nel lungo periodo.
          </p>
        </div>

        <div className="mt-16 flex justify-center">
          <Button size="lg" className="bg-[#F2C230] text-[#0E4B4A] hover:bg-[#F2C230]/90 font-bold px-8 py-6 text-lg shadow-md" asChild>
            <Link to="/ElectionProgramPage">
              Leggi il programma
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}